export const LOCATION_FILTERS_MESSAGES: any = {
    COUNTRY_TO_CHANGE: "This change will clear your State/Region selections in the Company and Contact Location filters.",
    COUNTRY_TO_CHANGE_ZIP: "This change will clear your Zip Code/Metro selections in the Company and Contact Location filters.",
    COUNTRY_TO_CHANGE_ZIP_REGION: "This change will clear your State/Region and Zip Code/Metro selections in the Company and Contact Location filters.",
    ZIPS_METROS_TO_CLEAR: "Switching to State will clear your Zip Code/Metro filters.",
    STATES_TO_CLEAR: "Switching to Zip Code/Metro will clear your State filters.",
}